import MapWrapper from '../../map-wrapper';
import LocationFilters from '../../location-filters';
import NewIekLocationFilters from './location-filters';
import FeatureFilters from './feature-filters';
import './style.scss';
import Select from './select';
import { useContext } from 'react';
import { StoresContext } from '../../../App';
import { useDebouncedSearch } from '../../../util/misc';
import StoreCards from '../../store-cards';
import StoreList from './store-list';
import OzonLogo from './images/ozon.webp';
import WbLogo from './images/wb.svg';
import YandexLogo from './images/yandex-market-seeklogo.svg'
import {
    transitions,
    positions,
    Provider as AlertProvider,
    AlertCustomOptions,
    AlertTemplateProps,
} from 'react-alert';

const features = {
    Special: 'Специализированный магазин',
    DIY: 'DIY',
    WebStore: 'Интернет магазин',
    Wholesale: 'Оптовые продажи',
    PanelAssembly: 'Сборщик электрощитового оборудования',
};
const featureOptions = Object.entries(features).map(([code, name]) => ({
    name,
    value: { code, value: null },
}));

const options = {
    // you can also just use 'bottom center'
    position: positions.TOP_CENTER,
    //timeout: 5000,
    offset: '50px',
    // you can also just use 'scale'
    transition: transitions.FADE,
};

interface AlertOptionsExt extends AlertCustomOptions {
    actions: { name: string; onClick: () => void; className?: string }[];
    title: string;
}

const AlertTemplate = ({ options, message, style }: AlertTemplateProps) => {
    const { actions = [], title = '' } = options as AlertOptionsExt;
    return (
        <div className="new-iek-popup" style={style}>
            <div className="popup-title">{title}</div>
            <div className="popup-message">{message}</div>
            <div className="popup-buttons">
                {actions.map(({ name, onClick, className = '' }) => (
                    <button key={name} className={'ui-button ' + className} onClick={onClick}>
                        {name}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default function NewIek() {
    const { featureFilters, setFeatureFilters, article, filterStock, setFilterStock } =
        useContext(StoresContext);
    const selectedFeature = features[featureFilters[0]?.code as keyof typeof features] || '';
    const search = useDebouncedSearch();

    return (
        <AlertProvider template={AlertTemplate} {...options}>
            <section className="where-buy new-iek">
                <div className="wrap">
                    <div className="container">
                        <div className="container-content container-content--w100">
                            <div className="partners map-container">
                                <h1 className="where-to-buy__title">
                                    Где купить {article ? `«${article}»` : ''}
                                </h1>
                                <div className="partners-search">
                                    <div className="ui-search ui-search--big">
                                        <div className="ui-input">
                                            <input
                                                className="ui-input__control ui-input__control--big ui-input__control--gray"
                                                placeholder="Введите название партнера, город или улицу для поиска"
                                                onInput={search}
                                            />
                                            <button type="button" className="ui-search__button">
                                                <i className="icon-search" />
                                            </button>
                                        </div>
                                        {article && (
                                            <div className="ui-input filter-checkboxes">
                                                <label className="ui-checkbox iek-prodcat-catalog-section-filter-values__value-wrap">
                                                    <input
                                                        className="ui-checkbox__control"
                                                        type="checkbox"
                                                        checked={filterStock}
                                                        onChange={(e) => setFilterStock(e.target.checked)}
                                                    />
                                                    <span className="ui-checkbox__icon" />
                                                    <span className="ui-checkbox__text">
                                                        Только с товаром
                                                    </span>
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div id="wereToBuyPartnerSelect" className="partners-select marketnavigator-filters">
                                    <LocationFilters render={NewIekLocationFilters} />
                                    <div className="partners-select-item">
                                        <Select
                                            name="Тип партнера"
                                            value={selectedFeature}
                                            options={featureOptions}
                                            onChange={(val) => setFeatureFilters(val ? [val] : [])}
                                        />
                                    </div>
                                </div>
                                <MapWrapper className="partners-map" />
                                <div className="marketplaces">
                                    Так же вы можете купить продукцию IEK GROUP на популярных маркетплейсах:
                                    <div className="mp-icons-container">
                                        <a href="https://www.ozon.ru/seller/iek-group-ofitsialnyy-magazin-proizvoditelya-1412513/products/?miniapp=seller_1412513">
                                            <img src={OzonLogo} alt="Ozon" className="mp-icon" />
                                        </a>
                                        <a href="https://www.wildberries.ru/seller/3945038">
                                            <img
                                                src={WbLogo}
                                                alt="Wildberries"
                                                className="mp-icon wildberries"
                                            />
                                        </a>
                                        <a href="https://market.yandex.ru/business--iek-group-ofitsialnyi-magazin-proizvoditelia/55520195">
                                            <img src={YandexLogo} alt="Yandex market" className="mp-icon" />
                                        </a>
                                    </div>
                                </div>
                                <FeatureFilters />
                                <StoreCards render={StoreList} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </AlertProvider>
    );
}
